import PermanentStorage from "../../util/storage";
export const localStoreStorage = new PermanentStorage("FTLLocalStore_");
//# sourceMappingURL=index.js.map